export default __webpack_public_path__ + "static/media/slider-smiles-3.3d6bcb69.jpg";